import { usePost, useGet } from '@/api/lib/integration.ts';
import type { ExtractDocumentResponse } from '@/api/documents/types.ts';
import type { RequestOptions } from '@/api/lib/types.ts';

export const extractDocument = (options: RequestOptions = {}) => usePost<{ uploadIds: number[] }, ExtractDocumentResponse>('/api/upload/extract-contract-data', options);

export const getExtractionAvailabilityStatus = useGet<void, { enabled: boolean }>('/api/upload/contract-data-extraction-status');
